import * as types from '../../types'
import {
    API_URL,
    plantillaEntity
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';

export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.PLANTILLAS_REINICIAR_ESTADO
        })
    }
}

export function getDataFromServer(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'Plantilla'
        const include = []
        const take = 100
        const filter = getState().plantillas.getIn(['filter'])
        const fields = ['nombre']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        axios.post(`${API_URL}/list`, {
                modelo,
                filters,
                include,
                skip,
                take,
                total: true
            })
            .then((res) => {
                const list = res.data.data.map(x => {
                    x._enabled = true
                    return x
                })
                const records = res.data.total
                dispatch(tableActions.mswTable_mostrarDatos('plantillas', 'plantillas', list, page, records))
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
    }
}

export function showHideModalCreate(show, id = null) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        if (!show) {
            dispatch({
                type: types.PLANTILLAS_MOSTRAR_OCULTAR_MODAL_CREATE,
                payload: {
                    show
                }
            })
            return
        }

        const item = id ? getState().plantillas.getIn(`plantillas.data.${id}`.split('.')).toJS() : plantillaEntity()
        dispatch({
            type: types.PLANTILLAS_MOSTRAR_OCULTAR_MODAL_CREATE,
            payload: {
                show,
                item,
            }
        })
    }
}

export function guardarPlantilla() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('plantillas', true))
        let data = getState().plantillas.getIn(['modalCreate', 'data'])
        const id = data.get('id3n71f13r')

        axios.post(`${API_URL}/plantillas`, data)
            .then(res => {
                const plantilla = res.data
                plantilla._enabled = true
                plantilla.id3n71f13r = id

                dispatch({
                    type: types.PLANTILLAS_ACTUALIZAR_REGISTROS,
                    payload: {
                        item: plantilla,
                        id
                    }
                })
                dispatch(tableActions.mwsTable_recalcularAnchoColumnas('plantillas', 'plantillas'))
                dispatch(showHideModalCreate(false))
                dispatch(setSavingState('plantillas', false))
                displayMessages(dispatch, {
                    success: 'Los registros han sido guardados exitosamente'
                })
                dispatch(getDataFromServer())
            })
            .catch(err => {
                console.log(err)
                dispatch(setSavingState('plantillas', false))
                displayMessages(dispatch, err)
            })
    }
}